import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import TonalIcon from "./TonalIcon";
import { ControlsConfig, PackageCarouselConfig } from "../package-carousel.props";

const styles = {
  cardControlButtonStyles: {
    p: "4px 8px 4px 8px",
    borderRadius: "50%",
    width: "36px",
    height: "36px"
  },
  iconStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "300px"
  },
  tonalButtonsContainer: {
    m: {
      xs: "0 20px 0 20px",
      sm: "0 32px 0 32px",
      md: "0 140px 0 140px"
    },
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }
};

export interface TonalIconContainerProps {
  autoScroll?: boolean;
  config: PackageCarouselConfig;
  controlsConfig: ControlsConfig;
  handleNext: () => void;
  handlePrev: () => void;
  handlePlayPause?: () => void;
}

const TonalIconContainer = (props: TonalIconContainerProps) => {
  const {
    autoScroll,
    controlsConfig,
    handleNext,
    handlePrev,
    handlePlayPause,
    config
  } = props;

  const { isAutoScrollNeeded, isLeftRightControlsNeeded } = config ?? {};
  try {
    return (
      <DtvBox
        data-testid="tonal-icon-container"
        sx={{
          ...styles.tonalButtonsContainer,
          ...(isLeftRightControlsNeeded && {
 m: 0,
justifyContent: "flex-end"
})
        }}
      >
        {/* tonal play/pause arrow control button */}
        {isAutoScrollNeeded && (
          <>
            {autoScroll ?
              controlsConfig?.pauseIcon && (
                  <TonalIcon
                    data-testid="tonal-icon-playpause"
                    {...controlsConfig?.pauseIcon}
                    handleOnClick={handlePlayPause}
                  />
                ) :
              controlsConfig?.playIcon && (
                  <TonalIcon
                    data-testid="tonal-icon-playpause"
                    {...controlsConfig?.playIcon}
                    handleOnClick={handlePlayPause}
                  />
                )}
          </>
        )}
        {(isAutoScrollNeeded || isLeftRightControlsNeeded) && (
          <DtvBox sx={{
 display: "flex",
gap: "12px"
}}>
            {/* tonal left arrow control button */}
            {controlsConfig?.prevIcon && (
              <TonalIcon
                data-testid="tonal-icon-prev"
                {...controlsConfig?.prevIcon}
                handleOnClick={handlePrev}
              />
            )}
            {/* tonal right arrow control button */}
            {controlsConfig?.nextIcon && (
              <TonalIcon
                data-testid="tonal-icon-next"
                {...controlsConfig?.nextIcon}
                handleOnClick={handleNext}
              />
            )}
          </DtvBox>
        )}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="Tonal Icon Container" error={error} />;
  }
};

export default React.memo(TonalIconContainer);
